<script>
import ConversationCard from 'dashboard/components/widgets/conversation/ConversationCard.vue';
import { mapGetters } from 'vuex';
import EstadoVazio from 'dashboard/components-next/EstadoVazio.vue';
import EsqueletoLista from 'dashboard/components-next/EsqueletoLista.vue';

export default {
  components: {
    ConversationCard,
    EstadoVazio,
    EsqueletoLista,
  },
  props: {
    contactId: {
      type: [String, Number],
      required: true,
    },
    conversationId: {
      type: [String, Number],
      required: true,
    },
    // Na ficha do contato (05/10/2026) não há conversa "atual": são TODAS as
    // conversas dele, e o texto não fala em "anterior".
    naFicha: { type: Boolean, default: false },
  },
  computed: {
    conversations() {
      return this.$store.getters['contactConversations/getContactConversation'](
        this.contactId
      );
    },
    previousConversations() {
      return this.conversations.filter(
        conversation => conversation.id !== Number(this.conversationId)
      );
    },
    ...mapGetters({
      uiFlags: 'contactConversations/getUIFlags',
    }),
    // "Nenhuma conversa anterior" e "não consegui carregar" são frases
    // diferentes: a busca que falha não pode parecer histórico vazio.
    falhou() {
      return !!this.uiFlags.fetchFailed;
    },
  },
  watch: {
    contactId(newContactId, prevContactId) {
      if (newContactId && newContactId !== prevContactId) {
        this.buscar(newContactId);
      }
    },
  },
  mounted() {
    this.buscar(this.contactId);
  },
  methods: {
    buscar(id) {
      this.$store.dispatch('contactConversations/get', id);
    },
  },
};
</script>

<template>
  <EsqueletoLista
    v-if="uiFlags.isFetching"
    :linhas="3"
    :altura="72"
    :rotulo="$t('CONTACT_PANEL.CONVERSATIONS.LOADING')"
  />

  <EstadoVazio
    v-else-if="falhou"
    class="ccv__vazio"
    tom="erro"
    icone="i-lucide-wifi-off"
    :titulo="$t('CONTACT_PANEL.CONVERSATIONS.LOAD_ERROR')"
  >
    <button
      type="button"
      class="advup-btn advup-btn--compacto"
      @click="buscar(contactId)"
    >
      <i class="i-lucide-rotate-cw" aria-hidden="true" />
      {{ $t('CONTACT_PANEL.CONVERSATIONS.RETRY') }}
    </button>
  </EstadoVazio>

  <EstadoVazio
    v-else-if="!previousConversations.length"
    class="ccv__vazio"
    icone="i-lucide-history"
    :titulo="
      naFicha
        ? $t('CONTACT_PANEL.CONVERSATIONS.FICHA_EMPTY_TITLE')
        : $t('CONTACT_PANEL.CONVERSATIONS.EMPTY_TITLE')
    "
    :dica="
      naFicha
        ? $t('CONTACT_PANEL.CONVERSATIONS.FICHA_EMPTY_HINT')
        : $t('CONTACT_PANEL.CONVERSATIONS.EMPTY_HINT')
    "
  />

  <div v-else class="ccv">
    <p class="advup-nota ccv__conta">
      {{
        $t(
          naFicha
            ? 'CONTACT_PANEL.CONVERSATIONS.FICHA_COUNT'
            : 'CONTACT_PANEL.CONVERSATIONS.COUNT',
          { count: previousConversations.length },
          previousConversations.length
        )
      }}
    </p>
    <!-- As conversas anteriores chegam em cascata, como as listas da casa (24/10/2026). -->
    <ConversationCard
      v-for="(conversation, i) in previousConversations"
      :key="conversation.id"
      class="advup-entra"
      :style="{ '--i': Math.min(i, 10) }"
      :chat="conversation"
      :hide-inbox-name="false"
      hide-thumbnail
      enable-context-menu
      compact
      :allowed-context-menu-options="['open-new-tab', 'copy-link']"
    />
  </div>
</template>

<style scoped>
/* O histórico do contato: as outras conversas dele, no mesmo cartão da
   lista (sem o rosto — é sempre a mesma pessoa). */
.ccv {
  display: flex;
  flex-direction: column;
}

.ccv__conta {
  margin: 0 0 var(--esp-1);
  padding: 0 var(--esp-1);
}

.ccv__vazio {
  padding: var(--esp-5) var(--esp-2);
}
</style>
